import { render, staticRenderFns } from "./Orden_de_compra.vue?vue&type=template&id=3cb34c65&lang=pug&"
import script from "./Orden_de_compra.vue?vue&type=script&lang=js&"
export * from "./Orden_de_compra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports